module.exports = __webpack_public_path__ + "img/SEVAS.fcaf4cf9.png";